import React, { useState, useEffect } from 'react';
import {useStock} from '../../contexts/stockContexts'; 
export default function ForecastOrdersHeader() {
  const [orderCount, setOrderCount] = useState(0);
  const [trend, setTrend] = useState(15.3);
  const [chartData, setChartData] = useState([]);
  const [isAnimating, setIsAnimating] = useState(false);
  const {instock,stockItems,ordergraphsdata} = useStock();

  // Generate random chart data
  const generateChartData = () => {
    const bars = 12;
    const data = [];
    for (let i = 0; i < bars; i++) {
      data.push(Math.random() * 70 + 30);
    }
    return data;
  };

  // Animate counter on mount
  useEffect(() => {
    const target = ordergraphsdata;
    const duration = 2000;
    const startTime = Date.now();

    const animate = () => {
      const now = Date.now();
      const progress = Math.min((now - startTime) / duration, 1);
      const current = Math.floor(progress * target);
      setOrderCount(current);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    animate();
    setChartData(generateChartData());
    // console.log(ordergraphsdata,'order graph data');
  }, [ordergraphsdata]);

  // Update forecast with new data
  const updateForecast = () => {
    if (isAnimating) return;
    
    setIsAnimating(true);
    const newOrder = Math.floor(Math.random() * 500) + 1000;
    const newTrend = parseFloat((Math.random() * 20 - 5).toFixed(1));
    
    const duration = 2000;
    const startValue = orderCount;
    const startTime = Date.now();

    const animate = () => {
      const now = Date.now();
      const progress = Math.min((now - startTime) / duration, 1);
      const current = Math.floor(startValue + (newOrder - startValue) * progress);
      setOrderCount(ordergraphsdata);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setIsAnimating(false);
      }
    };

    animate();
    setTrend(newTrend);
    setChartData(generateChartData());
  };

  // Auto-update every 10 seconds
  useEffect(() => {
    const interval = setInterval(updateForecast, 10000);
    return () => clearInterval(interval);
  }, [orderCount]);

  return (
    <>
      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 0.5; }
          50% { transform: scale(1.1); opacity: 0.8; }
        }

        @keyframes shimmer {
          0% { opacity: 1; }
          50% { opacity: 0.7; }
          100% { opacity: 1; }
        }

        .forecast-card {
          display:flex;
          position: relative;
          border: 1px solid #e1e1e1;
          background: white;
          border-radius: 0px;
          padding: 0px 20px;
          color: #333;
          min-width: 240px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          overflow: hidden;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          cursor: pointer;
         
        }

        .forecast-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
        }

        .forecast-card::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(102, 126, 234, 0.05) 0%, transparent 70%);
          animation: pulse 3s ease-in-out infinite;
        }

        .shimmer {
          animation: shimmer 2s infinite;
        }

        .bar {
          flex: 1;
          background: rgba(102, 126, 234, 0.2);
          border-radius: 3px 3px 0 0;
          transition: all 0.3s ease;
        }

        .forecast-card:hover .bar {
          background: rgba(102, 126, 234, 0.4);
        }
      `}</style>

      <div style={{
        display: 'flex',
        alignItems: 'center',
      }}>
        <div className="forecast-card" onClick={updateForecast}>
              
              
              <div style={{
                fontSize: '18px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'baseline',
                gap: '0px',
                position: 'relative',
                flexDirection:'column',
                zIndex: 1
              }}>
                <div style={{
                fontSize: '11px',
                opacity: 0.6,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                marginBottom: '6px',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                color: '#667eea'

              }}>
                <svg style={{ width: '16px', height: '16px' }} fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z"/>
                </svg>
                Forecast Orders Today
              </div>
                <div style={{display:'flex'}}>
                   <span className="shimmer">{orderCount}</span>
                   <div style={{
                fontSize: '13px',
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                // marginTop: '6px',
                opacity: 0.95,
                color: trend > 0 ? '#4ade80' : '#f87171'
              }}>
                <svg width="14" height="14" fill="currentColor" viewBox="0 0 20 20">
                  {trend > 0 ? (
                    <path fillRule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clipRule="evenodd"/>
                  ) : (
                    <path fillRule="evenodd" d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                  )}
                </svg>
                
                <span>{trend > 0 ? '+' : ''}{trend}%</span> vs yesterday
              </div>
                </div>
              </div>
              
              
              
              <div style={{
                display: 'flex',
                gap: '2px',
                alignItems: 'flex-end',
               
              }}>
                {chartData.map((height, index) => (
                  <div
                    key={index}
                    className="bar"
                    style={{ height: `${height}%` }}
                  />
                ))}
              </div>
            </div>
          </div>
      </>
  );
}